// extracted by mini-css-extract-plugin
module.exports = {"dashboardAlert":"DismissableAlert_dashboardAlert__7HB--","close":"DismissableAlert_close__3K6ld"};